export class DlsgSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enableClientSideDeployment",
            "baseName": "enableClientSideDeployment",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DlsgSettings.attributeTypeMap;
    }
    constructor() {
    }
}
